import OpenDownloadTool from './src/main';

/* istanbul ignore next */
OpenDownloadTool.install = function(Vue) {
  Vue.component(OpenDownloadTool.name, OpenDownloadTool);
};

export default OpenDownloadTool;
